import { render, staticRenderFns } from "./ClickAndReplace.vue?vue&type=template&id=5d40aa0a"
import script from "./ClickAndReplace.vue?vue&type=script&lang=js"
export * from "./ClickAndReplace.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports